import ApiError from '../../../../entities/api-error/ApiError'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestOrderStatusChange {
  type: DashboardActionTypes.REQUEST_ORDER_STATUS_CHANGE;
  payload: {
    orderId:    number
    nextStatus: string
  }
}

export function requestOrderStatusChange({
  orderId,
  nextStatus,
}: RequestOrderStatusChange['payload']): RequestOrderStatusChange {
  return {
    type: DashboardActionTypes.REQUEST_ORDER_STATUS_CHANGE,
    payload: {
      orderId,
      nextStatus,
    },
  }
}

export interface RequestOrderStatusChangeSuccess {
  type: DashboardActionTypes.REQUEST_ORDER_STATUS_CHANGE_SUCCESS;
  payload: {
    orderId:    number
  }
}

export function requestOrderStatusChangeSuccess({
  orderId,
}: RequestOrderStatusChangeSuccess['payload']): RequestOrderStatusChangeSuccess {

  return {
    type: DashboardActionTypes.REQUEST_ORDER_STATUS_CHANGE_SUCCESS,
    payload: {
      orderId,
    },
  }
}

export interface RequestOrderStatusChangeFailure {
  type: DashboardActionTypes.REQUEST_ORDER_STATUS_CHANGE_FAILURE;
  payload: {
    orderId:  number
    error:    ApiError;
  }
}

export function requestOrderStatusChangeFailure({
  orderId,
  error,
}: RequestOrderStatusChangeFailure['payload']): RequestOrderStatusChangeFailure {

  return {
    type: DashboardActionTypes.REQUEST_ORDER_STATUS_CHANGE_FAILURE,
    payload: {
      orderId,
      error,
    },
  }
}
